import React from 'react';
import { LucideIcon } from 'lucide-react';

interface CardProps {
  title?: React.ReactNode;
  children: React.ReactNode;
  icon?: LucideIcon;
  actions?: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}

export function Card({ title, children, icon: Icon, actions, className = '', noPadding = false }: CardProps) {
  const hasHeader = title || Icon || actions;
  return (
    <div className={`card ${className}`}>
      {hasHeader && (
        <div className="card-header">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              {Icon && <Icon className="h-4.5 w-4.5 text-primary flex-shrink-0" />}
              {title && <h2 className="text-sm font-semibold text-card-foreground">{title}</h2>}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
          </div>
        </div>
      )}
      <div className={hasHeader ? (noPadding ? '' : 'card-body') : (noPadding ? '' : 'p-6')}>
        {children}
      </div>
    </div>
  );
}
